import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": /*@__PURE__*/_normalizeClass(['message-abstract-image'])
};
var _hoisted_2 = ["src"];
export default /*@__PURE__*/_defineComponent({
  __name: 'message-abstract-image',
  props: {
    messageContent: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        "class": _normalizeClass(['messageImage']),
        src: __props.messageContent.url
      }, null, 8, _hoisted_2)]);
    };
  }
});